import React, { useState, useEffect,forwardRef, useImperativeHandle } from 'react';
// import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Select from '../../CommonComponent/ReactSelect';
import * as ConstantOptions from '../../Utils/ConstantOptions';
import compair from '../../CommonComponent/SortDropDown';
import InputMask from '../../CommonComponent/NumberFormat';
import { editIconTooltip, deleteIconTooltip, saveIconTooltip, resetIconTooltip, updateIconTooltip } from '../../CommonComponent/CommonIconTooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import formatDisplayData from '../../CommonComponent/DisplayContentFormatter';
import isEmptyValidation from '../../../components/Validation/EmptyError';

let constantOptions = ConstantOptions.DROPDOWN_OPTIONS

const ContactTab = forwardRef((props,ref) => {
    let contactData = props.contactData;
    let setContactData = props.setContactData;
    let setContactDataTemp = props.setContactDataTemp;

    const [contactType, setContactType] = useState();
    const [contactUse, setContactUse] = useState();
    const [number, setNumber] = useState("");
    const [email, setEmail] = useState("");
    const [extension, setExtension] = useState("");
   
    const [notificationCheckForContact, setNotificationCheckForContact] = useState(false);
    // const [isNotificationCheckShow,setIsNotificationCheckShow] = useState(true);

    const [editedIndexForContact, setEditedIndexForContact] = useState(null);

    const [contactTypeisEmpty, setContactTypeisEmpty] = useState(false);
    const [contactUseisEmpty, setContactUseisEmpty] = useState(false);
    const [numberisEmpty, setNumberisEmpty] = useState(false);
    const [emailisEmpty, setEmailisEmpty] = useState(false);
    const [contactUseOptions , setContactUseOptions] = useState([]);

  
    // useEffect(()=>{
    //     if(!isNotificationCheckShow)
    //         setNotificationCheckForContact(false)
    // },[isNotificationCheckShow]);

    useImperativeHandle(ref, () => ({
        resetContactOnClickOfSubmit() {
            resetContact();
        }
      }));

    useEffect(()=>{
        isValidForSaveOnClickOfSubmit();
    },[contactType,contactUse,number,email,extension,notificationCheckForContact]);

    const isValidForSaveOnClickOfSubmit = () =>{
        if((contactType !== undefined && contactType !== null && contactType.value !== undefined && contactType.value !== "") && (contactUse !== undefined && contactUse !== null && contactUse.value !== undefined && contactUse.value !== "") && (number !== "" || email !== ""))
        {
            if(validateContact(false))
            {
                saveContactInTemp();
            }
        }
        else{
            setContactDataTemp([]);
        }
    }

    const saveContactInTemp=()=>{
        let contact = ""
        contactType.value === "Email" ? contact = email : contact = number
        setContactDataTemp([]);
        let coArray=[];
        let addToArrayValuesTemp = {
            settedContactType: contactType !== "" && contactType.value !== "" ? contactType : "",
            settedContactUse: contactUse !== "" && contactUse.value !== "" ? contactUse : "",
            settedNumber: contact,
            settedExtension: extension,
            settedNotificationContactCheck: notificationCheckForContact,
        };
        if (editedIndexForContact != null) {
            addToArrayValuesTemp = { ...addToArrayValuesTemp, "id": editedIndexForContact }
        }
        else {
            addToArrayValuesTemp = { ...addToArrayValuesTemp, "id": contactData !== [] && contactData.length!==0 ? contactData[contactData.length-1].id + 1 : 1 }
        }
        coArray.push(addToArrayValuesTemp);
        setContactDataTemp(coArray);
    }

    const validateContact = (isFromSubmit) => {
        let isValidContact = true;
        const emailRegex = (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/);

        let isEmptyValidationArray=[
            {"fieldName":contactType,"functionName":setContactTypeisEmpty}, 
            {"fieldName":contactUse,"functionName":setContactUseisEmpty}
        ]

        isEmptyValidationArray.forEach(item=>{
            if(!isEmptyValidation(item.fieldName,item.functionName))
                isValidContact=false 
        })

        if (contactType != null && contactType.value === "Email" && !isEmptyValidation(email,setEmailisEmpty,!emailRegex.test(email))) 
            isValidContact=false 

        if(contactType != null && contactType.value === "Phone" && !isEmptyValidation(number, setNumberisEmpty, number.replace(/\s/g, "").length !== 12))
            isValidContact=false 

        if (isValidContact) {
            if(isFromSubmit)
                saveContact();
            else
                return true;
        }
    }

    const saveContact = () => {
        let contact = ""
        contactType.value === "Email" ? contact = email : contact = number

        let addToArrayValues = {
            settedContactType: contactType !== "" && contactType.value !== "" ? contactType : "",
            settedContactUse: contactUse !== "" && contactUse.value !== "" ? contactUse : "",
            settedNumber: contact,
            settedExtension: extension,
            settedNotificationContactCheck: notificationCheckForContact,
        };


        if (editedIndexForContact != null) {
            addToArrayValues = { ...addToArrayValues, "id": editedIndexForContact }
            let newArr = [...contactData];
            if (contactData !== [] && contactData.length !== 0) {
                contactData.forEach((item, index) => {
                    if (item.id === editedIndexForContact) {
                        newArr[index] = addToArrayValues;
                    }
                })
            }

            setContactData(newArr);
        }
        else {
            addToArrayValues = { ...addToArrayValues, "id": contactData.length!==0 ? contactData[contactData.length-1].id + 1 : 1 }
            setContactData([...contactData, addToArrayValues]);
        }

        resetContact();

    }

    const resetContact = e => {
        setContactType(""); setContactUse(""); setNumber(""); setExtension(""); setEmail("");
        setEditedIndexForContact(null);  setNotificationCheckForContact(false);
        setNumberisEmpty(false); setEmailisEmpty(false); setContactTypeisEmpty(false); setContactUseisEmpty(false);
        setContactUseOptions([]);
    }

    const editContact = (editData) => {

        if (editData.id && editData.id !== "") {
            setEditedIndexForContact(editData.id);
        }

        if (editData !== "" && editData != null) {
            setContactType(editData.settedContactType); setContactUse(editData.settedContactUse);
            setExtension(editData.settedExtension);
            if (editData.settedContactType.value === "Email") {
                setEmail(editData.settedNumber);
            }
            else {
                setNumber(editData.settedNumber);
            }
         
            setNotificationCheckForContact(editData.settedNotificationContactCheck);
            setContactTypeisEmpty(false); setContactUseisEmpty(false); setNumberisEmpty(false); setEmailisEmpty(false);
        }

    }

    const deleteContact = (deleteData) => {

        if (deleteData.id && deleteData.id !== "") {
            let newArr = [...contactData];

            if (contactData !== [] && contactData.length !== 0) {
                contactData.forEach((item, index) => {
                    if (item.id === deleteData.id) {
                        newArr.splice(index, 1);
                    }
                })
            }

            setContactData(newArr);
        }
    }

    const contactTypeHandleChange = contactType => {

        setContactUseOptionsFromTypeOptions(contactType);

        setContactType(contactType); setContactTypeisEmpty(false); setContactUseisEmpty(false); 
        setNumberisEmpty(false); setEmailisEmpty(false); 
        setNumber(""); setEmail(""); setContactUse(""); setExtension("");
    }

    const setContactUseOptionsFromTypeOptions = (contactType) =>{
        setContactUseOptions([]);
        if(contactType !== null && contactType.value === "Phone")
            setContactUseOptions(constantOptions.contactPhoneUseOptions);
        else if(contactType !== null && contactType.value === "Email")
            setContactUseOptions(constantOptions.contactEmailUseOptions);
    }

    const contactUseHandleChange = contactUse => {
        setContactUseOptionsFromTypeOptions(contactType);
        setContactUse(contactUse); setContactUseisEmpty(false); setExtension("");
    }

    const numberHandleChange = number => {
        setNumber(number.target.value); setNumberisEmpty(false);
    }

    const emailHandleChange = email => {
        setEmail(email.target.value); setEmailisEmpty(false);
    }

    const extensionHandleChange = extension => {
        if (extension.target.value.length > 5) extension.target.value = extension.target.value.slice(0, 5);
        setExtension(extension.target.value);
    }

    const notificationCheckForContactHandleChange = event => {
        setNotificationCheckForContact(!notificationCheckForContact);
    }

    const formatSingleSelectValueForContact = (row) => {

        let contactString=(row.settedContactType.value + (row.settedContactUse !== undefined && row.settedContactUse.value !== undefined ? ', (' + row.settedContactUse.value + ') ' : '') + ', ' + row.settedNumber + (row.settedExtension !== undefined && row.settedExtension !== "" ? '×' + row.settedExtension : ''));
        return (<div className="tds-detail-address">{formatDisplayData(contactString,'80')}   {row.settedPrimaryContactCheck ? <span className="tds-primary-tag"> Primary</span> : ''} {row.settedNotificationContactCheck ? <span className="tds-primary-tag"> Receive Notification</span> : ''}</div>)
    }

    const setIconForContact = (row) => {
        return (
            <div>
                <OverlayTrigger placement={"bottom"} overlay={editIconTooltip}>
                    <span onClick={() => editContact(row)}><i className="fa fa-edit"></i></span>
                </OverlayTrigger>
                <OverlayTrigger placement={"bottom"} overlay={deleteIconTooltip}>
                    <span onClick={() => deleteContact(row)}><i className="fa fa-trash"></i></span>
                </OverlayTrigger>
            </div>
        );
    }


    return (
        <div className="inner-card">
            <div className="card-header">
                Contact
            </div>
            <div className="card-inner-body">
                <div className="tds-row">
                    <div className="tds-column">
                        <div className={contactTypeisEmpty ? "tds-validation" : ""}>
                            <label htmlFor="cars">Method*</label>
                            <Select
                                className={"custom_select_box"}
                                options={constantOptions.contactTypeOptions.sort(compair)}
                                id={"contactType"}
                                value={contactType}
                                handleChange={contactTypeHandleChange}
                            />
                        </div>
                    </div>
                        <div className="tds-column">
                            <div className={contactUseisEmpty ? "tds-validation" : ""}>
                                <label htmlFor="cars">Type*</label>
                                <Select
                                    className={"custom_select_box"}
                                    options={contactUseOptions.sort(compair)}
                                    id={"contactUse"}
                                    value={contactUse}
                                    handleChange={contactUseHandleChange}
                                />
                            </div>
                        </div>

                    <div className="tds-column">

                        {contactType !== undefined && contactType !== null && contactType.value !== undefined && contactType.value === "Email" ?
                            <div className={emailisEmpty ? "tds-validation" : ""}>
                                <label htmlFor="email">Email*</label>
                                <input type="text" id="email" name="email" value={email} onChange={emailHandleChange} placeholder="Email" maxLength={50} autoComplete="none"/>
                            </div>
                            :
                            <div className={numberisEmpty ? "tds-validation" : ""}>
                                <label htmlFor="number">Number*</label>
                                <InputMask
                                    id="number"
                                    name="number"
                                    value={number}
                                    pattern={"number"}
                                    handleChange={numberHandleChange}
                                    placeholder={"000-000-0000"}
                                    autoComplete="none"
                                />
                            </div>
                        }

                    </div>

                    {contactType !== undefined && contactUse !== undefined && contactType !== null && contactUse !== null && contactType.value === "Phone" && (contactUse.value === "Home" || contactUse.value === "Office")
                        ?
                        <div className="tds-column">
                            <label htmlFor="extension">Extension</label>
                            <input type="number" id="extension" name="extension" value={extension} onChange={extensionHandleChange} placeholder="Extension" autoComplete="none"/>
                        </div>
                        : null
                    }

                    <div className="tds-column-checkbox tds-column-contact-checkbox">
                    <span className="tds-checkbox mr15">
                                <input type="checkbox" id="notificationCheckForContact" name="notificationCheckForContact" onChange={notificationCheckForContactHandleChange} checked={notificationCheckForContact} autoComplete="none"/>
                                <label htmlFor="notificationCheckForContact">Receive Notification</label>
                            </span>
                       
                       
                    </div>

                </div>

                <div className="tds-reset-btn-grp">
                    <div className="tds-column-btn">
                        <div className="tds-btn-group">
                            <OverlayTrigger placement={"bottom"} overlay={editedIndexForContact!=="" && editedIndexForContact!==null ? updateIconTooltip : saveIconTooltip}>
                                <button className="btn btn-blue" onClick={()=>validateContact(true)}><i className="fa fa-plus"></i></button>
                            </OverlayTrigger>
                            <OverlayTrigger placement={"bottom"} overlay={resetIconTooltip}>
                                <button className="btn btn-blue" onClick={resetContact}><i className="fa fa-undo"></i></button>
                            </OverlayTrigger>
                        </div>
                    </div>
                </div>

                <div className="custom-tds-table custom-tds-two-column-table table-responsive">         

                    <table className="table">
                    <thead>
                        <tr>
                        <th scope="col">Contact</th>
                        <th scope="col">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                         {
                            contactData.map((item) => (
                                <tr key={item.id}>
                                    <td>{formatSingleSelectValueForContact(item)}</td>
                                    <td>{setIconForContact(item)}</td>
                                </tr>
                            ))
                        }
                    </tbody>
                    </table>
                </div>
            </div>

        </div>
    )
});
export default ContactTab;